module.exports = __webpack_public_path__ + "img/maven.720b236a.png";